import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { Button } from "PFComponents/button";
import { useShortlistAssign } from "PFCore/hooks/queries/shortlists/use_shortlist_actions";
import { useUnbiasedProfileName } from "PFCore/hooks/use_unbiased_profile_name";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useCurrentActivity } from "../hooks/use_current_activity";

const AssignButton = ({ item, item: { profile, state }, isUnbiasedMode }) => {
  const { t } = useTranslation("activities");

  // items.state == "assign" corresponds to "Invite" action (see: PF-3540, PF-4138)
  const hasBeenInvited = state === "assigned";
  const text = hasBeenInvited ? t("invited") : t("invite");
  const kind = hasBeenInvited ? "secondary" : "primary";
  const { showGrowl } = useGrowlStoreActions();
  const activity = useCurrentActivity();
  const { mutate: assignShortlist } = useShortlistAssign();
  const { getUnbiasedProfileName } = useUnbiasedProfileName();

  const reviewing = activity.review && activity.review.state !== "complete";

  const notificationName = getUnbiasedProfileName(profile, isUnbiasedMode);

  return (
    <Button
      text={text}
      kind={kind}
      disabled={reviewing}
      qaId="shortlist-assign"
      onClick={() => {
        assignShortlist(item.id, {
          onSuccess: () => {
            showGrowl({
              message: t("show.parts.roleAssignedNotification", { notificationName: notificationName }),
              kind: "success"
            });
          }
        });
      }}
    />
  );
};

export default AssignButton;

AssignButton.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
    state: PropTypes.string,
    profile: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      id: PropTypes.number
    })
  }).isRequired,
  isUnbiasedMode: PropTypes.bool
};
